export const removeQueryParams = (params: string | string[]): string => {
  const { pathname, search } = window.location;

  const urlSearchParams = new URLSearchParams(search);

  if (typeof params === 'string') {
    urlSearchParams.delete(params);
  }

  if (Array.isArray(params)) {
    params.map((param) => {
      urlSearchParams.delete(param);
    });
  }

  return `${pathname}${urlSearchParams.toString() !== '' ? '?' : ''}${urlSearchParams}`;
};

export default removeQueryParams;
